import { removeAccessAndRefreshTokens } from "../lib/general/token";

export const handleLogout = () => {
  removeAccessAndRefreshTokens();
};

export const capitalizedString = (string: string) => {
  if (!string) {
    return "";
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const countryStateData = [
  {
    name: "INDIA",
    key: "india",
    states: [
      "Andhra Pradesh",
      "Arunachal Pradesh",
      "Assam",
      "Bihar",
      "Chhattisgarh",
      "Goa",
      "Gujarat",
      "Haryana",
      "Himachal Pradesh",
      "Jharkhand",
      "Karnataka",
      "Kerala",
      "Madhya Pradesh",
      "Maharashtra",
      "Manipur",
      "Meghalaya",
      "Mizoram",
      "Nagaland",
      "Odisha",
      "Punjab",
      "Rajasthan",
      "Sikkim",
      "Tamil Nadu",
      "Telangana",
      "Tripura",
      "Uttar Pradesh",
      "Uttarakhand",
      "West Bengal",
      "Andaman and Nicobar Islands",
      "Chandigarh",
      "Dadra and Nagar Haveli and Daman and Diu",
      "Delhi",
      "Jammu and Kashmir",
      "Ladakh",
      "Lakshadweep",
      "Puducherry",
    ],
  },
  {
    name: "USA",
    key: "usa",
    states: [
      "California",
      "Texas",
      "Florida",
      "New York",
      "Illinois",
      "Pennsylvania",
      "Ohio",
      "Georgia",
      "North Carolina",
      "Michigan",
      "New Jersey",
      "Virginia",
      "Washington",
      "Arizona",
      "Massachusetts",
      "Tennessee",
      "Indiana",
      "Missouri",
      "Maryland",
      "Wisconsin",
      "Colorado",
      "Minnesota",
      "South Carolina",
      "Alabama",
      "Louisiana",
      "Kentucky",
      "Oregon",
      "Oklahoma",
      "Connecticut",
      "Iowa",
      "Mississippi",
      "Arkansas",
      "Kansas",
      "Nevada",
      "Utah",
      "Nebraska",
      "West Virginia",
      "Idaho",
      "Hawaii",
      "New Mexico",
      "Montana",
      "Rhode Island",
      "Delaware",
      "South Dakota",
      "North Dakota",
      "Alaska",
      "Vermont",
      "Wyoming",
      "New Hampshire",
      "Maine",
    ],
  },
  {
    name: "CANADA",
    key: "canada",
    states: [
      "Ontario",
      "Quebec",
      "British Columbia",
      "Alberta",
      "Nova Scotia",
      "Newfoundland and Labrador",
      "New Brunswick",
      "Prince Edward Island",
      "Manitoba",
      "Saskatchewan",
      "Northwest Territories",
      "Yukon",
      "Nunavut",
    ],
  },
  {
    name: "AUSTRALIA",
    key: "australia",
    states: [
      "New South Wales",
      "Queensland",
      "Victoria",
      "South Australia",
      "Western Australia",
      "Tasmania",
      "Australian Capital Territory (ACT)",
      "Northern Territory",
    ],
  },
  {
    name: "NEW ZEALAND",
    key: "new_zealand",
    states: [
      "Auckland",
      "Wellington",
      "Christchurch",
      "Hamilton",
      "Bay of Plenty",
      "Northland",
      "Taranaki",
      "Waikato",
      "Canterbury",
      "Otago",
      "Hawke's Bay",
      "Marlborough",
      "Nelson",
      "Southland",
      "Gisborne",
      "Manawatu-Wanganui",
    ],
  },
  {
    name: "GERMANY",
    key: "germany",
    states: [
      "Bavaria",
      "Berlin",
      "North Rhine-Westphalia",
      "Hesse",
      "Saxony",
      "Brandenburg",
      "Thuringia",
      "Baden-Württemberg",
      "Rhineland-Palatinate",
      "Lower Saxony",
      "Mecklenburg-Vorpommern",
      "Saarland",
      "Hamburg",
      "Bremen",
      "Schleswig-Holstein",
      "Saxony-Anhalt",
    ],
  },
];

export function capitalizeFirstLetter(str: string): string {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}
